import React from 'react';
import styles from './AdsSectionLoader.scss';

const AdsSectionLoader = () => (

    <div className={styles.adsWrapper}>

        <div className={styles.adSingle}> 
            <div className={`${styles.adImage} ${styles.skeletonLoader}`}></div>

            <div className={styles.adInfo}>
                <div className={` ${styles.skeletonLoader} ${styles.date}`} ></div>
                <div className={styles.topContent}>
                    <span className={`${styles.textOne} ${styles.skeletonLoader}`}></span>
                    <span className={`${styles.textTwo} ${styles.skeletonLoader}`}></span>
                </div>
                <div className={styles.bottomContent}>
                    <span className={`${styles.textOne} ${styles.skeletonLoader}`}></span>
                    <span className={`${styles.textTwo} ${styles.skeletonLoader}`}></span>
                </div>
            </div>

        </div>
        <div className={styles.adSingle}>
            <div className={`${styles.adImage} ${styles.skeletonLoader}`}></div>

            <div className={styles.adInfo}>
                <div className={` ${styles.skeletonLoader} ${styles.date}`}></div>
                <div className={styles.topContent}>
                    <span className={`${styles.textOne} ${styles.skeletonLoader}`}></span>
                    <span className={`${styles.textTwo} ${styles.skeletonLoader}`}></span>
                </div>
                <div className={styles.bottomContent}>
                    <span className={`${styles.textOne} ${styles.skeletonLoader}`}></span>
                    <span className={`${styles.textTwo} ${styles.skeletonLoader}`}></span>
                </div>
            </div>

        </div>
        <div className={`${styles.adSingle} ${styles.thirdAdSingle}`}>
            <div className={`${styles.adImage} ${styles.skeletonLoader}`}></div>

            <div className={styles.adInfo}>
                <div className={` ${styles.skeletonLoader} ${styles.date}`}></div>
                <div className={styles.topContent}>
                    <span className={`${styles.textOne} ${styles.skeletonLoader}`}></span>
                    <span className={`${styles.textTwo} ${styles.skeletonLoader}`}></span>
                </div>
                <div className={styles.bottomContent}>
                    <span className={`${styles.textOne} ${styles.skeletonLoader}`}></span>
                    <span className={`${styles.textTwo} ${styles.skeletonLoader}`}></span>
                </div>
            </div>

        </div>
    </div>
)


export default AdsSectionLoader;



// WEBPACK FOOTER //
// ./src/containers/SearchPage/AdsSectionLoader/index.tsx